import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-crm-tareas',
  templateUrl: './crm-tareas.component.html',
  styleUrls: ['./crm-tareas.component.css']
})
export class CrmTareasComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
